// extracted by mini-css-extract-plugin
export var image = "PartnerAccountIconImage-module__image___SuK-S";
export var studioImageIcon = "PartnerAccountIconImage-module__studioImageIcon___N2-pe";